export const htmlSanitizer=(str:string):string=>{
    let tmp = document.createElement("DIV");
    tmp.innerHTML = str;
    return tmp.textContent || tmp.innerText || "";
}
